import type { RowBgColorPreset, RowBgColorResult } from './types';

export const ROW_BG_COLOR_PRESETS: Record<RowBgColorPreset, string> = {
  'light-blue': '#DBEAFE',
  'light-yellow': '#FEF9C3',
  'light-green': '#DCFCE7',
  'light-red': '#FEE2E2',
  'light-orange': '#FFEDD5',
  'light-purple': '#F3E8FF',
  'light-gray': '#F3F4F6',
};

export function resolveRowBgColor(result: RowBgColorResult | undefined): string | undefined {
  if (!result) return undefined;
  if (result.hex) return result.hex;
  if (result.preset) return ROW_BG_COLOR_PRESETS[result.preset];
  return undefined;
}
